
import Vue from "vue";
import { INode } from "@/shared/models/node.model";

export default Vue.extend({
    name: "ListItem",
    props: {
        item: Object as () => INode,
        chapter: Object as () => INode,
        activeNodeId: Number
    },
    data() {
        return {
            isExpanded: false as boolean,
            isActive: false as boolean,
            isLongName: false as boolean,
        };
    },
    watch: {
        activeNodeId(value: number) {
            if (value > 0) {
                this.isActive = this.item.Id === value;
                if (this.isActive) {
                    this.$emit("expand-parent");
                }
            } else if (value === -1) {
                this.isExpanded = false;
            }
        }
    },
    mounted() {
        if (this.item.Name.length > 35) {
            this.isLongName = true;
        }
        if (this.activeNodeId !== 0 && this.activeNodeId === this.item.Id) {
            this.isActive = true;
            this.$emit("expand-parent");
        }
    },
    methods: {
        expand() {
            this.isExpanded = !this.isExpanded;
        },
        expandMe() {
            this.isExpanded = true;
            this.$emit("expand-parent");
        },
        showItem(selectedItem: INode) {
            this.$emit("show-item", selectedItem, this.chapter);
        }
    }
});
